import { FleekError } from './FleekError';

type Record = {
  id?: string;
  name?: string;
};

type IpnsRecordNotFoundErrorOptions = {
  record: Record;
};

export class IpnsRecordNotFoundError extends FleekError<IpnsRecordNotFoundErrorOptions> {
  public name = 'IpnsRecordNotFoundError';

  toString = () => `IPNS record not found.`;
}
